import { Constants, usePlatformShare } from 'core';
import { ContactOrganizerModal, ShareModal, ShareQRCodeModal } from 'core/Components';
import { useCauseParam } from 'core/Hooks';
import { BASE_URL } from 'core/Utils';
import { useNavigate } from 'react-router-dom';
import { ButtonMantine, Group, KebabMenu } from 'ui';
import { useDisclosure } from 'ui/Hooks';
import { IconShare } from 'ui/Icons';

const TeamHeaderActions = ({
  causeId,
  campaignId,
  teamId,
  teamName,
  teamConvention,
  participantConvention,
  hasEditAccess,
}: {
  causeId: string;
  campaignId: string;
  teamId: string;
  teamName: string;
  teamConvention: string;
  participantConvention: string;
  hasEditAccess: boolean;
}) => {
  const { data: cause } = useCauseParam();

  const navigate = useNavigate();

  const [isContactModalOpen, contactHandlers] = useDisclosure(false);
  const [isShareModalOpen, shareHandlers] = useDisclosure(false);
  const [isQRCodeModalOpen, qrCodeHandlers] = useDisclosure(false);

  const { platformShare } = usePlatformShare();

  const teamPageLink = `${BASE_URL}${Constants.appRoutes.participantCenter(
    causeId,
    campaignId
  )}/teams/${teamId}`;

  const causePageRoute = `${Constants.appRoutes.cause(causeId)}`;
  const campaignPageRoute = `${Constants.appRoutes.campaign(causeId, campaignId)}`;

  const participantCenterRoute = `${Constants.appRoutes.participantCenter(causeId, campaignId)}`;

  return (
    <>
      <Group gap="xs">
        <ButtonMantine
          size="sm"
          variant="white"
          color="gray"
          leftSection={<IconShare />}
          onClick={() =>
            void platformShare(
              {
                share_options: { url: teamPageLink },
              },
              () => shareHandlers.open()
            )
          }
        >
          Share
        </ButtonMantine>
        <KebabMenu
          items={[
            {
              label: 'Contact Organizer',
              onClick: () => contactHandlers.open(),
            },
            {
              label: 'Share QR Code',
              onClick: () => qrCodeHandlers.open(),
              visible: hasEditAccess,
            },
            {
              withDivider: true,
              label: 'Visit Cause Page',
              onClick: () => navigate(causePageRoute),
            },
            { label: 'Visit Campaign Page', onClick: () => navigate(campaignPageRoute) },
            {
              label: `Visit ${participantConvention} Center`,
              onClick: () => navigate(participantCenterRoute),
            },
          ]}
          buttonProps={{ variant: 'white', color: 'gray', size: 'sm' }}
        />
      </Group>
      <ContactOrganizerModal
        causeId={causeId}
        campaignId={campaignId}
        opened={isContactModalOpen}
        onClose={contactHandlers.close}
      />
      <ShareModal
        opened={isShareModalOpen}
        onClose={shareHandlers.close}
        imgSrc={cause?.logo?.url}
        link={teamPageLink}
        title={`Share This ${teamConvention} Fundraising Page`}
        causeName={cause?.name}
        description="Share this link to invite friends"
      />
      <ShareQRCodeModal
        link={teamPageLink}
        description={`${teamName}'s Fundraising Page`}
        opened={isQRCodeModalOpen}
        onClose={qrCodeHandlers.close}
      />
    </>
  );
};

export { TeamHeaderActions };
